import React from "react";

export const TreeContext = React.createContext();